<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <br /><span class="text-uppercase page-subtitle"
            >visão comercial</span
          >
          <h3 class="page-title">Clientes Inativos</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <b-button
              v-if="countFilter > 0"
              variant="primary"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes inativos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loading"></loader>
              <table class="table mb-0" v-if="!loading">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Cliente</th>
                    <th scope="col" class="border-0" v-if="filter.IdPartnerType != 0">Parceiro</th>
                    <th scope="col" class="border-0">Origem</th>
                    <th scope="col" class="border-0">Responsável</th>
                    <th scope="col" class="border-0">Contato do Responsável</th>
                    <th scope="col" class="border-0">Data do cadastro</th>
                    <th scope="col" class="border-0" v-if="$isAuthorize('Merchant', 'Get')"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(merchant, index) in merchants" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{ merchant.Name | substring(50) }}</div>
                      <span>{{ merchant.Identity | identity }}</span>
                    </td>
                    <td v-if="filter.IdPartnerType != 0">
                      {{ merchant.Partner.Name }}
                    </td>
                    <td>
                      <div>{{ merchant.SourceDescription }}</div>
                    </td>
                    <td>
                      <div>{{ merchant.ResponsibleName }}</div>
                      <span class="td-span-style">{{
                        merchant.ResponsibleIdentity | identity
                      }}</span>
                    </td>
                    <td>
                      <div
                        v-if="
                          merchant.ResponsiblePhone != null &&
                          merchant.ResponsiblePhone != undefined &&
                          merchant.ResponsiblePhone != ''
                        "
                      >
                        {{ merchant.ResponsiblePhone | phone }}
                      </div>
                      <div v-else>Não informado</div>
                      <span class="td-span-style">{{ merchant.Email }}</span>
                    </td>
                    <td>
                      <span>{{ merchant.CreatedDate | date }}</span>
                    </td>
                    <td v-if="$isAuthorize('Merchant', 'Get')">
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        title="Visualizar"
                        v-on:click="OpenMerchant($event, merchant.Id)"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      merchants == undefined ||
                      merchants == null ||
                      merchants.length == 0
                    "
                  >
                    <td colspan="8">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Nome"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            placeholder="CPF/CNPJ"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.NumberDays" :value="null">
            <option :value="30" selected>1 mês sem transacionar</option>
            <option :value="60" selected>2 meses sem transacionar</option>
            <option :value="90" selected>3 meses sem transacionar</option>
            <option :value="120" selected>4 meses sem transacionar</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdPartnerType" :value="null">
            <option :value="0" selected>Sem parceiro</option>
            <option
              v-for="type in partnerTypes"
              :key="type.Name"
              :value="type.Id"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "merchantnottransacting",
  data: function () {
    return {
      countFilter: 0,
      loading: false,
      loadingReport: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Identity: null,
        Name: null,
        NumberDays: 60,
        IdPartnerType: 0,
      },
      idMerchant: 0,
      merchants: [],
      partnerTypes: [],
    };
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListMerchantNotTransacting();
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchantNotTransacting();
    },
  },
  mounted() {
    let params = this.$route.query;
    if (params != null && params.previous) {
      const qs = require("qs");
      let prev = qs.parse(params.previous);
      if (prev.pagination != null) {
        this.pagination = this.RemoveNullData(prev.pagination, true);
      }
      if (prev.filter != null) {
        this.filter = this.RemoveNullData(prev.filter);
      }
    }
    this.ListMerchantNotTransacting();
    this.ListPartnerType();
  },
  methods: {
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchantNotTransacting();
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportMerchantNotTransacting", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    HideModal: function () {
      this.$bvModal.hide("mFormMerchant");
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Identity": this.filter.Identity,
        "Object.Name": this.filter.Name,
        "Object.Partner.PartnerType.Id": this.filter.IdPartnerType,
        NumberDays: this.filter.NumberDays,
        IsCommercial: true,
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    ListMerchantNotTransacting: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.NumberDays)) this.countFilter++;
      if (hasValue(this.filter.IdPartnerType)) this.countFilter++;
      this.loading = true;
      let params = this.GetParamsData();
      this.$store
        .dispatch("ListMerchantNotTransacting", { params: params })
        .then((response) => {
          this.merchants = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os clientes",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
    ListPartnerType: function () {
      this.$store
        .dispatch("ListPartnerType")
        .then((response) => {
          this.partnerTypes = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de tipos de parceiro",
            error
          );
        });
    },
    OpenMerchant: function (e, idMerchant) {
      e.preventDefault();
      if (idMerchant) {
        const qs = require("qs");
        this.$router.push({
          name: "merchants",
          query: {
            mId: idMerchant,
            previous: qs.stringify({
              pagination: this.pagination,
              filter: this.filter,
              component: this.$route.name,
            }),
          },
        });
      }
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    RemoveNullData: function (obj, onlyInt) {
      for (let prop in obj) {
        if (hasValue(obj[prop]) == false) obj[prop] = null;
        else if (onlyInt) {
          obj[prop] = parseInt(obj[prop], 10) || obj[prop];
        }
      }
      return obj;
    },
    ResetFilter: function () {
      this.filter = {
        Identity: null,
        Name: null,
        NumberDays: 60,
        IdPartnerType: 0,
      };
      this.ListMerchantNotTransacting();
    },
  },
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/merchantNotTransactingCommercial.vue